import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Search } from "lucide-react";
 * // Use <Search /> instead
 */
export const SearchIcon = createSVGWrapper(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.708 12.886a6.25 6.25 0 1 1 1.178-1.178l4.084 4.083a.833.833 0 0 1-1.178 1.178l-4.084-4.084Zm.792-4.97a4.583 4.583 0 1 1-9.166 0 4.583 4.583 0 0 1 9.166 0Z"
    clipRule="evenodd"
  />,
  "0 0 20 20"
);
